module.exports = __webpack_public_path__ + "media/images/wedding/thumb/20-4cd914f5f702c36fb8690f6dd6dd6f1d.jpg";